module.exports = __webpack_public_path__ + "ba7cebf39a9b37d0af8848511802a7d6.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/gallery/crows-feet/crows-feet-1a.jpg
 ** module id = 431
 ** module chunks = 0
 **/